<!-- This example requires Tailwind CSS v2.0+ -->
<template>
  <a class="link" @click.prevent="open = true">
    <i class="fa-solid fa-eye"></i><span class="space-icon"></span>Ver detalles
  </a>
  <TransitionRoot as="template" :show="open">
    <Dialog
      as="div"
      class="fixed z-10 inset-0 overflow-y-auto"
      @close="open = false"
    >
      <div
        class="flex items-end justify-center min-h-screen pt-4 px-4 pb-20 text-center sm:block sm:p-0"
      >
        <TransitionChild
          as="template"
          enter="ease-out duration-300"
          enter-from="opacity-0"
          enter-to="opacity-100"
          leave="ease-in duration-200"
          leave-from="opacity-100"
          leave-to="opacity-0"
        >
          <DialogOverlay
            class="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity"
          />
        </TransitionChild>

        <!-- This element is to trick the browser into centering the modal contents. -->
        <span
          class="hidden sm:inline-block sm:align-middle sm:h-screen"
          aria-hidden="true"
          >&#8203;</span
        >
        <TransitionChild
          as="template"
          enter="ease-out duration-300"
          enter-from="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
          enter-to="opacity-100 translate-y-0 sm:scale-100"
          leave="ease-in duration-200"
          leave-from="opacity-100 translate-y-0 sm:scale-100"
          leave-to="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
        >
          <div
            class="relative inline-block align-bottom bg-white rounded-lg px-4 pt-5 pb-4 text-left overflow-hidden shadow-xl transform transition-all sm:my-8 sm:align-middle sm:max-w-4xl sm:w-full sm:p-6"
          >
            <div class="hidden sm:block absolute top-0 right-0 pt-4 pr-4">
              <button
                type="button"
                class="bg-white rounded-md text-gray-400 hover:text-slate-500 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-white"
                @click="open = false"
              >
                <span class="sr-only">Close</span>
                <i class="h-6 w-6 fa-solid fa-xmark"></i>
              </button>
            </div>
            <div class="sm:flex sm:items-start">
              <div class="mt-3 sm:mt-0 sm:ml-4 sm:text-left sm:w-full">
                <DialogTitle
                  class="text-lg leading-6 font-medium text-gray-900"
                >
                  Detalle
                </DialogTitle>

                <div class="py-5">
                  <dl
                    class="grid sm:grid-cols-1 md:grid-cols-2 gap-x-4 gap-y-8"
                  >
                    <div class="sm:col-span-1">
                      <dt class="text-base font-medium text-gray-500">Fecha</dt>
                      <dd class="mt-1 text-base text-gray-900">10 Ene 2020</dd>
                    </div>
                    <div class="sm:col-span-1">
                      <dt class="text-base font-medium text-gray-500">
                        Empaques
                      </dt>
                      <dd class="mt-1 text-base text-gray-900">
                        100 Cajas de 4.2 Kg
                      </dd>
                    </div>
                    <div class="sm:col-span-1">
                      <dt class="text-base font-medium text-gray-500">
                        Total (Kg)
                      </dt>
                      <dd class="mt-1 text-base text-gray-900">1000 kg</dd>
                    </div>

                    <div class="sm:col-span-1">
                      <dt class="text-base font-medium text-gray-500">
                        Agroexportadora
                      </dt>
                      <dd class="mt-1 text-base text-gray-900">Fairtrasa</dd>
                    </div>

                    <div class="sm:col-span-1">
                      <dt class="text-base font-medium text-gray-500">
                        Contenedores
                      </dt>
                      <dd class="mt-1 text-base text-gray-900">TEMU0987652</dd>
                    </div>

                    <div class="col-span-2">
                      <dd class="mt-1 text-base text-gray-900">
                        <div class="inline-block min-w-full py-2 align-middle">
                          <div
                            class="overflow-hidden shadow ring-1 ring-black ring-opacity-5 md:rounded-lg"
                          >
                            <table class="table">
                              <thead class="table-header">
                                <tr>
                                  <th scope="col" class="table-header-cell">
                                    Lote
                                  </th>
                                  <th scope="col" class="table-header-cell">
                                    Fecha
                                  </th>
                                  <th scope="col" class="table-header-cell">
                                    Productor
                                  </th>
                                  <th scope="col" class="table-header-cell">
                                    Empaques
                                  </th>
                                  <th scope="col" class="table-header-cell">
                                    Total (Kg)
                                  </th>
                                  <th scope="col" class="table-header-cell">
                                    Pallet
                                  </th>
                                </tr>
                              </thead>
                              <tbody class="table-body">
                                <tr
                                  class="table-row"
                                  v-for="harvested_exp_package in harvested_exp_packages"
                                  :key="harvested_exp_package.id"
                                >
                                  <td class="table-cell">
                                    L001
                                  </td>
                                  <td class="table-cell">10 Ene 2021</td>
                                  <td class="table-cell">Pedro Perez</td>
                                  <td class="table-cell">190</td>
                                  <td class="table-cell">1,710 Kg</td>
                                  <td class="table-cell">
                                    P-001
                                  </td>
                                </tr>
                              </tbody>
                            </table>
                          </div>
                        </div>
                      </dd>
                    </div>
                  </dl>
                </div>
              </div>
            </div>
            <div class="mt-5 sm:mt-4 sm:flex sm:flex-row-reverse">
              <button
                type="button"
                class="mt-3 w-full inline-flex justify-center rounded-md border border-slate-300 shadow-sm px-4 py-2 bg-white text-base font-medium text-gray-700 hover:text-slate-500 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-[#5c7a2e] sm:mt-0 sm:w-auto sm:text-sm"
                @click="open = false"
              >
                Cerrar
              </button>
            </div>
          </div>
        </TransitionChild>
      </div>
    </Dialog>
  </TransitionRoot>
</template>

<script>
import BasicProductionRequester from "@/views/open_queries/requesters/producer/basic_production.js";

import { ref } from "vue";
import {
  Dialog,
  DialogOverlay,
  DialogTitle,
  TransitionChild,
  TransitionRoot
} from "@headlessui/vue";

export default {
  name: "OQProducerBasicProductionDetails",
  components: {
    Dialog,
    DialogOverlay,
    DialogTitle,
    TransitionChild,
    TransitionRoot
  },
  props: ["harvested_batch"],
  setup() {
    const open = ref(false);

    return {
      open
    };
  },
  data() {
    return {
      data_loaded: false,
      harvested_packages: [],
      harvested_exp_packages: [{}]
    };
  },
  methods: {
    fetchHarvestedBatches: async function () {
      if (!this.data_loaded) {
        let response = await BasicProductionRequester.getProductionDetails(
          this.harvested_batch.id
        );
        this.harvested_packages = response.data.harvested_packages;
        this.harvested_exp_packages = response.data.harvested_exp_packages;
        this.data_loaded = true;
      }
    }
  }
};
</script>
